import React from "react";
import Tempo from "../assets/Tempo.jpeg";

const TempoPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6">
      {/* Contêiner principal */}
      <div className="flex flex-col md:flex-row items-center max-w-4xl w-full">
        {/* Imagem (sempre centralizada) */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={Tempo}
            alt="Tempo"
            className="w-full h-auto rounded-lg shadow-lg"
          />
        </div>

        {/* Texto (sempre centralizado) */}
        <div className="w-full md:w-1/2 mt-6 md:mt-0 md:pl-8 text-center">
          <h1 className="text-3xl font-bold text-[#ad6a51] mb-4">
            O tempo vai passar do mesmo jeito
          </h1>
          <p className="text-lg text-[#4a4a4a] leading-relaxed">
            <br />
            Quantos sonhos você deixou de tentar conquistar por achar que não iria conseguir? Quantos objetivos você deixou de alcançar por achar que é tarde para começar algo novo?
            <br />
            <br />
            Não há tempo certo para dar o primeiro passo. O tempo vai passar do mesmo jeito. Aproveite a caminhada.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TempoPage;
